import React from 'react';
import { View } from 'react-native';
import PropTypes from 'prop-types';
import { SocialPost } from './SocialPost';
import { SupportedSocialPlatforms } from '../SocialLink';
import Utils from '../../../common/Utils';

const SocialPostContainer = ({ contentItems = {}, nodeTypeAlias = 'SocialPostContainer', width, ...rest }) => {
    return (
        <View dataSet={{ umbracoComponentName: nodeTypeAlias }}>
            {Object.values(contentItems)?.map(post => {
                const rest2 = Utils.splitKeyFromProps(post).rest;
                if ('reactSocialPostFacebook'.equals(post.nodeTypeAlias)) {
                    return <SocialPost key={post.id} type={SupportedSocialPlatforms.FACEBOOK} width={width} {...rest} {...rest2} />;
                } else if ('reactSocialPostTwitter'.equals(post.nodeTypeAlias)) {
                    return <SocialPost key={post.id} type={SupportedSocialPlatforms.XTWITTER} width={width} {...rest} {...rest2} />;
                } else if ('reactSocialPostYouTube'.equals(post.nodeTypeAlias)) {
                    return <SocialPost key={post.id} type={SupportedSocialPlatforms.YOUTUBE} width={width} {...rest} {...rest2} />;
                } else if ('reactSocialPostInstagram'.equals(post.nodeTypeAlias)) {
                    return <SocialPost key={post.id} type={SupportedSocialPlatforms.INSTAGRAM} width={width} {...rest} {...rest2} />;
                }
            })}
        </View>
    );
};

SocialPostContainer.propTypes = {
    contentItems: PropTypes.object
};

export default SocialPostContainer;
